import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timi-logo-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "timi.tools", -1)
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("i", {
      class: "svgicon",
      innerHTML: _ctx.store.getters.svgIcons.timi
    }, null, 8, _hoisted_3)
  ]))
}